// pp-account-track.js — F6: tracking de los bloques "crea tu cuenta" (PDP,
// tira PDP/Home, carrito, colección) y de las páginas del área de cuenta.
//
// NO es un cliente nuevo: reusa 100% el compartido por F2/F5 en
// snippets/pp-visitor-tracking.liquid — window._ppTrack.send(event, surface,
// detail) manda el mismo visitor_key/session_key al mismo endpoint
// track-event, con el mismo sendBeacon-o-fetch-keepalive. Si ese snippet no
// corrió (tienda sin chat_supabase_* configurado, navegador sin storage o sin
// crypto.randomUUID — el aviso de cookies ya NO lo apaga, 5-oct-2026) window._ppTrack no existe y este módulo
// entero queda inerte — cero red, cero listeners.
//
// Hooks que cablea (ver data-pp-track en snippets/pp-account-benefits*.liquid
// y sections/pp-collection-{nav,detailed}.liquid):
//   *_view  -> IntersectionObserver, dispara solo cuando el bloque entra de
//              verdad al viewport (>=50% visible). Una vez por sesión por
//              evento (dedupe sessionStorage) — evita doble disparo por
//              scroll in/out/in.
//   *_cta   -> click delegado en document (cubre también los links que
//              assets/pp-account-benefits.js inyecta después del fetch de
//              estatus fiscal, que no existen en el DOM al cargar esta página).
// Páginas de cuenta (/account*, /pages/cliente-*) -> account_page_view con
// el área derivada del path (dashboard/orders/facturacion/empresa/etc.), UNA
// vez por carga de página (igual que el page view de F2 — no se dedupea:
// cada navegación real es una vista real).
(function () {
  'use strict';

  var track = window._ppTrack;
  if (!track || typeof track.send !== 'function') return; // tracking deshabilitado

  var SEEN_PREFIX = 'pp_acct_seen:';

  function seen(key) {
    try { return sessionStorage.getItem(SEEN_PREFIX + key) === '1'; } catch (e) { return false; }
  }
  function markSeen(key) {
    try { sessionStorage.setItem(SEEN_PREFIX + key, '1'); } catch (e) { /* noop */ }
  }

  // Superficie derivada del nombre del evento — ver contrato en el brief:
  // benefits_view -> pdp_section, benefits_strip_view -> pdp_strip,
  // benefits_cart_view -> cart, benefits_collection_view -> collection.
  // El orden importa: "strip"/"cart"/"collection"/"home" se checan antes
  // del default pdp_section porque "benefits_strip_view" también contiene
  // "benefits".
  function surfaceFor(event) {
    if (event.indexOf('strip') !== -1) return 'pdp_strip';
    if (event.indexOf('cart') !== -1) return 'cart';
    if (event.indexOf('collection') !== -1) return 'collection';
    if (event.indexOf('home') !== -1) return 'home';
    return 'pdp_section';
  }

  // ---- Vistas de bloque: IntersectionObserver, exposición real ----
  var viewEls = document.querySelectorAll('[data-pp-track$="_view"]');
  if (viewEls.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var event = el.getAttribute('data-pp-track');
        if (!event || seen(event)) return;
        markSeen(event);
        track.send(event, surfaceFor(event));
      });
    }, { threshold: 0.5 });

    viewEls.forEach(function (el) {
      var event = el.getAttribute('data-pp-track');
      if (event && seen(event)) return; // ya visto esta sesión, ni observar
      io.observe(el);
    });
  }

  // ---- Clics de CTA: delegado en document, cubre links inyectados después ----
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest && e.target.closest('[data-pp-track$="_cta"]');
    if (!el) return;
    var event = el.getAttribute('data-pp-track');
    if (!event) return;
    var cta = el.getAttribute('data-pp-cta') || null;
    track.send(event, surfaceFor(event), cta ? { cta: cta } : null);
  }, false);

  // ---- Páginas del área de cuenta ----
  function areaFromPath(path) {
    var pageMatch = path.match(/^\/pages\/cliente-([a-z0-9-]+)/i);
    if (pageMatch) return pageMatch[1];
    var accountMatch = path.match(/^\/account\/?([a-z0-9_-]*)/i);
    if (accountMatch) return accountMatch[1] || 'dashboard';
    return 'other';
  }

  var path = location.pathname;
  var isAccountArea = /^\/account(\/|$)/i.test(path) || /^\/pages\/cliente-/i.test(path);
  if (isAccountArea) {
    track.send('account_page_view', 'account', { area: areaFromPath(path) });
  }
})();
